import { useState, useEffect } from 'react';
import {
  CheckCircle2,
  Briefcase,
  Building2,
  Clock,
  Bot,
  Mail,
  Palette,
  Users,
  ArrowRight,
  Sparkles
} from '../../icons/wp-icons';

function AbschlussStep({ onDataChange, onboardingData, user }) {
  useEffect(() => {
    onDataChange({}, true);
  }, []);

  const branche = onboardingData?.branchenKonfiguration?.branche;
  const firmendaten = onboardingData?.firmendaten;

  const completedSteps = [
    {
      icon: Briefcase,
      title: 'Branche',
      value: branche ? branche.charAt(0).toUpperCase() + branche.slice(1) : 'Nicht festgelegt',
      completed: !!branche
    },
    {
      icon: Building2,
      title: 'Firmendaten',
      value: firmendaten?.firmenname || 'Nicht ausgefüllt',
      completed: !!firmendaten?.firmenname
    },
    {
      icon: Clock,
      title: 'Öffnungszeiten',
      value: 'Konfiguriert',
      completed: !!onboardingData?.branchenKonfiguration?.oeffnungszeiten
    },
    {
      icon: Bot,
      title: 'KI-Agent',
      value: 'Bereit',
      completed: true
    }
  ];

  const optionalSteps = [
    { icon: Mail, title: 'E-Mail', configured: false },
    { icon: Palette, title: 'Branding', configured: false },
    { icon: Users, title: 'Team', configured: false }
  ];

  return (
    <div className="space-y-8">
      {/* Erfolgs-Header */}
      <div className="text-center">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <Sparkles className="w-10 h-10 text-green-600" />
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-2">
          Alles bereit!
        </h3>
        <p className="text-gray-600">
          Ihr WerkPilot ist konfiguriert und einsatzbereit.
        </p>
      </div>

      {/* Zusammenfassung */}
      <div className="bg-gray-50 rounded-xl p-6">
        <h4 className="font-medium text-gray-900 mb-4">Ihre Konfiguration</h4>

        <div className="space-y-3">
          {completedSteps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="flex items-center gap-3">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
                  step.completed ? 'bg-green-100 text-green-600' : 'bg-gray-200 text-gray-400'
                }`}>
                  {step.completed ? (
                    <CheckCircle2 className="w-5 h-5" />
                  ) : (
                    <Icon className="w-4 h-4" />
                  )}
                </div>
                <div className="flex-1">
                  <span className="text-gray-600">{step.title}:</span>{' '}
                  <span className="font-medium text-gray-900">{step.value}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Nächste Schritte */}
      <div className="border rounded-xl p-6">
        <h4 className="font-medium text-gray-900 mb-4">Empfohlene nächste Schritte</h4>

        <div className="space-y-4">
          <a
            href="/einstellungen?tab=email"
            className="flex items-center gap-4 p-4 bg-blue-50 hover:bg-blue-100 rounded-lg transition"
          >
            <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
              <Mail className="w-5 h-5 text-blue-600" />
            </div>
            <div className="flex-1">
              <div className="font-medium text-gray-900">E-Mail-Konto verbinden</div>
              <div className="text-sm text-gray-600">
                Damit der KI-Agent Anfragen bearbeiten kann
              </div>
            </div>
            <ArrowRight className="w-5 h-5 text-gray-400" />
          </a>

          <a
            href="/kunden"
            className="flex items-center gap-4 p-4 bg-gray-50 hover:bg-gray-100 rounded-lg transition"
          >
            <div className="w-10 h-10 bg-gray-200 rounded-lg flex items-center justify-center">
              <Users className="w-5 h-5 text-gray-600" />
            </div>
            <div className="flex-1">
              <div className="font-medium text-gray-900">Ersten Kunden anlegen</div>
              <div className="text-sm text-gray-600">
                Oder Kunden aus einer CSV-Datei importieren
              </div>
            </div>
            <ArrowRight className="w-5 h-5 text-gray-400" />
          </a>

          <a
            href="/kalender"
            className="flex items-center gap-4 p-4 bg-gray-50 hover:bg-gray-100 rounded-lg transition"
          >
            <div className="w-10 h-10 bg-gray-200 rounded-lg flex items-center justify-center">
              <Clock className="w-5 h-5 text-gray-600" />
            </div>
            <div className="flex-1">
              <div className="font-medium text-gray-900">Kalender erkunden</div>
              <div className="text-sm text-gray-600">
                Termine verwalten und Google Kalender verbinden
              </div>
            </div>
            <ArrowRight className="w-5 h-5 text-gray-400" />
          </a>
        </div>
      </div>

      {/* Abschluss-Info */}
      <div className="bg-gradient-to-r from-[#378ab2] to-[#2a6d8a] rounded-xl p-6 text-white text-center">
        <h4 className="font-medium text-lg mb-2">
          Willkommen bei WerkPilot, {user?.name?.split(' ')[0]}!
        </h4>
        <p className="text-blue-100 text-sm">
          Klicken Sie auf "Fertig", um zum Dashboard zu gelangen.
        </p>
      </div>
    </div>
  );
}

export default AbschlussStep;
